import { HttpResponse, ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import { logger } from 'logger';
import { withApiBaseUrl } from 'services/utils/with-api-base-url';
import { CustomerOrdersStats, GetCustomerOrdersStatsResult } from './types';

const serviceName = 'customerOrderOrchestration';
const BASE_URL = withApiBaseUrl(config.services.customerOrderOrchestration.path);

class CustomerOrderOrchestrationServiceClient extends ServiceClient {
  async getCustomerOrdersStats(authHeader: string): Promise<GetCustomerOrdersStatsResult> {
    const { data, error } = await this.httpClient
      .get<CustomerOrdersStats>('/customerorders/stats', {
        headers: {
          Authorization: authHeader,
          breadcrumb: config.applicationName,
        },
      })
      .catch(e => ({ error: e }) as HttpResponse<CustomerOrdersStats>);

    if (!data || error) {
      logger.error({
        payload: {
          service: serviceName,
          url: `${BASE_URL}/customerorders/stats`,
          message: `Error getting customer orders stats: ${
            error?.message || 'Customer orders stats missing from response'
          }`,
        },
      });

      return {
        data,
        error: {
          message: error?.message || 'Missing response data',
        },
      };
    }

    return { data };
  }
}

export default new CustomerOrderOrchestrationServiceClient(BASE_URL);
